<template>
  <v-theme-provider dark>
    <base-section
      id="info-alt"
      class="primary"
    >
      <v-responsive
        class="mx-auto mt-n12 info-alt-shell"
        max-width="1400"
        :height="infoHeight"
      >
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <base-info />
            </v-col>

            <v-col
              cols="12"
              md="3"
            >
              <base-info-card title="Kontak" />

              <base-business-contact dense />
            </v-col>

            <v-col
              cols="12"
              md="3"
            >
              <info-features />
            </v-col>

            <v-col
              cols="12"
              md="3"
            >
              <product-features />
            </v-col>
          </v-row>
        </v-container>
      </v-responsive>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionBusinessInfo',

    components: {
      InfoFeatures: () => import('@/components/InfoFeatures'),
      ProductFeatures: () => import('@/components/ProductFeatures'),
    },
    computed: {
      infoHeight () {
        return this.$vuetify.breakpoint.mdAndUp ? 375 : undefined
      },
    },
  }
</script>

<style lang="sass">
  #info-alt a
    text-decoration: none

  @media (max-width: 959.98px)
    .info-alt-shell
      margin-top: 0 !important
</style>
